import type { RelativeDateTimeInterval } from 'cadenza/relative-date-time/relative-date-time-interval';
import type { RelativeDateTimeSign } from 'cadenza/conditions/condition-date-picker/condition-date-picker-modal';
import type { RelativeDateIntervalUnit } from 'cadenza/relative-date-time/relative-date-interval-unit';

export interface CustomRelativeDateTimeInputValues {
  sign: RelativeDateTimeSign;
  amount: number;
  unit: RelativeDateIntervalUnit;
  includeCurrent: boolean;
}

export function inputValuesToRelativeDateInterval ({ sign, amount, unit, includeCurrent }: CustomRelativeDateTimeInputValues) {
  const signFactor = toSignFactor(sign);
  const includeCurrentOffset = includeCurrent ? 0 : 1;
  const offset = toPositiveZero(signFactor * (amount + includeCurrentOffset - 1));
  const start = toPositiveZero(signFactor * includeCurrentOffset);

  return {
    unit,
    from: sign === 'LAST' ? offset : start,
    to: sign === 'LAST' ? start : offset
  };
}

export function relativeDateTimeToInputValues ({ unit, from, to }: RelativeDateTimeInterval): CustomRelativeDateTimeInputValues {
  const sign = getSign(from, to);
  const amount = Math.abs(from - to) + 1;
  const includeCurrent = (sign === 'LAST' ? to : from) === 0;
  return { sign, amount, unit, includeCurrent };
}

function getSign (from: number, to: number): RelativeDateTimeSign {
  if (from === 0 && to === 0) {
    return 'THIS';
  }

  return from < 0 ? 'LAST' : 'NEXT';
}

function toSignFactor (sign: RelativeDateTimeSign) {
  if (sign === 'THIS') {
    return 0;
  }
  return sign === 'LAST' ? -1 : 1;
}

function toPositiveZero (value: number) {
  // eslint-disable-next-line no-compare-neg-zero
  return value === -0 ? 0 : value;
}
